@if(newIn){
<div class="new-in container-fluid">
  <div class="title">
    <h2>
      {{"New In"|translate}}
    </h2>
    <!-- <a routerLink="/main/new-in">
      {{"View All"|translate}}
    </a> -->
  </div>
  <div class="products">
    @for (product of newIn.materials; track product.sapCode) {

    <app-product [product]="product" [newIn]="true"></app-product>
    <!-- <button class="product btn btn-light">
      <app-asset [assetSrc]="product.media"></app-asset>
      <div class="text sapcode">
        {{product.sapCode}}
      </div>
      <div class="text sapcode">
        {{product.catalogCode}}
      </div>

    </button> -->
    }
  </div>
</div>
}
